import React from 'react';
import { Eye } from 'lucide-react';

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Step 3 — focused document list (suggested ones pre-ticked) with preview of the picked ones only.
export const DocPicker = ({ documents, picked, setPicked, suggested }) => (
  <div className="bg-white border border-[#E2E2DF] rounded-md p-4" data-testid="ur-doc-picker">
    <div className="text-sm font-bold text-slate-800 mb-2">Documents to resend</div>
    <div className="space-y-1.5">
      {documents.map((d) => {
        const on = picked.includes(d.key);
        return (
          <div key={d.key} className="flex items-center gap-2 text-xs">
            <input type="checkbox" data-testid={`ur-doc-${d.key}`} checked={on}
              onChange={() => setPicked(on ? picked.filter((k) => k !== d.key) : [...picked, d.key])} />
            <span className={on ? 'font-semibold text-slate-800' : 'text-slate-600'}>{d.label}</span>
            {suggested.includes(d.key) && <span className="text-[10px] px-1.5 py-0.5 rounded bg-amber-50 text-amber-700 border border-amber-200">affected by changes</span>}
            {on && (
              <a data-testid={`ur-preview-${d.key}`} href={`${BACKEND}/api${d.route}`} target="_blank" rel="noreferrer"
                className="ml-auto inline-flex items-center gap-1 text-[#1A73E8] hover:underline"><Eye size={12} /> Preview</a>
            )}
          </div>
        );
      })}
    </div>
  </div>
);
